import { useFormik } from "formik";
import { useDispatch } from "react-redux";

import { Form, Input } from "components/Form";
import { usePartnerships } from "hooks/usePartnerships";
import { QuiverContainer } from "./Quiver.styles";
import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Loader } from "components/Loader";
import { Button } from "components/Button";

export const QuiverTab = () => {
  const dispatch = useDispatch();
  const { isLoading, partnerships, connectPartnership } = usePartnerships();
  const quiverPartnership = partnerships?.quiver || {};

  const formik = useFormik({
    initialValues: { code: "" },
    onSubmit: async (values, { resetForm }) => {
      try {
        const result = await connectPartnership("quiver", values.code);
        if (result.success) {
          resetForm();
        }
      } catch (error) {
        dispatch(
          toast({
            type: "error",
            body: parseErrorMessage(error),
          })
        );
      }
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <QuiverContainer>
      <h3>Quiver Partnership</h3>
      {quiverPartnership.status === "active" ? (
        <div className="content-section">
          <p>Your Quiver integration is active and connected.</p>
        </div>
      ) : (
        <div className="content-section">
          <p>
            {quiverPartnership.description ||
              "Connect your Quiver account to get started."}
          </p>
          {quiverPartnership.setup_instructions && (
            <p className="setup-instructions">
              {quiverPartnership.setup_instructions}
            </p>
          )}
          <Form onSubmit={formik.handleSubmit} className="connection-form">
            <Input
              label="Authentication Code"
              placeholder="Enter your authentication code"
              required
              {...formik.getFieldProps("code")}
            />
            <Button
              type="submit"
              variant="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <Loader className="on-btn" />
              ) : (
                "Connect Quiver"
              )}
            </Button>
          </Form>
        </div>
      )}
    </QuiverContainer>
  );
};
